
$(document).ready(function () {

$(document).ready(function () {
  var $wrapper = $('.announcement-bar-wrapper');
  var scrollSpeed = parseInt($wrapper.data('scroll-speed')) || 5000;

  $wrapper.slick({
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: 3,
    autoplay: true,
    autoplaySpeed: 0,
    speed: scrollSpeed,
    cssEase: 'linear',
    pauseOnHover: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 }},
      { breakpoint: 992,  settings: { slidesToShow: 2 }},
      { breakpoint: 600,  settings: { slidesToShow: 2 }}
    ]
  });
});

  var $marqueeWrapper = $('.marquee-wrapper');
  var marqueeSpeed = parseInt($marqueeWrapper.data('scroll-speed')) || 5000;

  $(".marquee-track").slick({
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: 3,
    autoplay: true,
    autoplaySpeed: 0,
    speed: marqueeSpeed,
    cssEase: "linear",
    pauseOnHover: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 }},
      { breakpoint: 992,  settings: { slidesToShow: 2 }},
      { breakpoint: 600,  settings: { slidesToShow: 1 }}
    ]
  });


 // $('.product-grid.contains-card').slick('unslick'); // Destroy existing slider
// Wait until all new items are appended to the grid
//  setTimeout(function () {
 // $(".product-grid.contains-card").slick({
 //    //dots: false,
 //    arrows: true,
 //    infinite: true,
 //     slidesToShow: 4,
 //     slidesToScroll: 1,
 //      // autoplay: false,
 //      //autoplaySpeed: 0,
 //      // speed: 3000,
 //     // pauseOnHover: false,
 //    responsive: [{
 //        breakpoint: 1024,
 //        settings: {
 //           slidesToShow: 3,
 //        }
 //      },
 //      {
 //        breakpoint: 992,
 //        settings: {
 //          slidesToShow: 2,
 //        }
 //      },
 //      {
 //        breakpoint: 600,
 //        settings: {
 //           slidesToShow: 2,
 //        }
 //      },

 //    ]
 //  });
//}, 100);

// Go to previous slide
// $('.slider-button--prev').on('click', function () {
//   $('.product-grid.contains-card').slick('slickPrev');
// });

// // Go to next slide
// $('.slider-button--next').on('click', function () {
//   $('.product-grid.contains-card').slick('slickNext');
// });
  
})